<template>
  <el-container>
    <el-aside width="160px">
      <el-tabs tab-position="left" @tab-click="handleClick" v-model="current">
        <el-tab-pane
          :label="label(card)"
          :key="index"
          v-for="(card, index) in cards"
        />
      </el-tabs>
    </el-aside>
    <el-main ref="main" @scroll.native.passive="handleScroll">
      <el-form
        v-if="form"
        ref="form"
        label-width="96px"
        label-position="left"
        label-suffix="："
      >
        <!--LDAP设置-->
        <el-card class="box-card">
          <div slot="header" class="box-card-header">
            <span>LDAP设置</span>
            <span>
              <el-button type="text" @click="ldapConnectionTest"
                >连接测试</el-button
              >
              <save-button @click="handleSave">保存设置</save-button>
              <!--<el-button type="text">
                保存设置 <i class="el-icon-warning-outline"></i
              ></el-button>-->
            </span>
          </div>
          <el-form-item label="主机地址">
            <el-input v-model="form.ldap.host"></el-input>
          </el-form-item>
          <el-form-item label="根目录">
            <el-input v-model="form.ldap.root"></el-input>
          </el-form-item>
          <el-form-item label="传输加密">
            <el-checkbox v-model="form.ldap.useSsl">启用SSL</el-checkbox>
          </el-form-item>
          <el-form-item label="只读模式" v-if="dataSource === 'LDAP'">
            <el-checkbox v-model="form.ldap.readOnlyMode"
              >启用只读模式（启用该模式将关闭LDAP节点属性修改功能）</el-checkbox
            >
          </el-form-item>
          <el-form-item label="端口号">
            <el-input v-model="form.ldap.port"></el-input>
          </el-form-item>
          <el-form-item label="连接用户名">
            <el-input v-model="form.ldap.user"></el-input>
          </el-form-item>
          <el-form-item label="连接密码">
            <el-input type="password" v-model="form.ldap.password"></el-input>
          </el-form-item>
        </el-card>
        <!--网易设置-->
        <el-card class="box-card">
          <div slot="header" class="box-card-header">
            <span>网易设置</span>
            <save-button @click="handleSave">保存设置</save-button>
          </div>
          <el-form-item label="域名">
            <el-input v-model.trim="form.netease.domain"></el-input>
          </el-form-item>
          <el-form-item label="产品">
            <el-input v-model.trim="form.netease.product"></el-input>
          </el-form-item>
          <el-form-item label="区域">
            <el-input v-model.trim="form.netease.area"></el-input>
          </el-form-item>
          <el-form-item label="子域名">
            <el-input
              v-model.trim="form.netease.subDomains"
              placeholder="多个子域名之间使用英文','分隔"
            ></el-input>
          </el-form-item>
          <el-form-item label="私钥">
            <el-input
              type="textarea"
              :rows="4"
              resize="none"
              placeholder="不修改请留空"
              v-model.trim="form.netease.key"
            ></el-input>
          </el-form-item>
          <el-form-item label="域名映射">
            <el-button size="mini" type="primary" @click="checkForm()"
              >添加</el-button
            >
            <table class="condition-table">
              <tr
                v-for="(condition, index) in form.netease.mailDomainlists"
                :key="index"
              >
                <td class="td-value">
                  <el-form-item
                    :prop="'conditions[' + index + '].text'"
                    :blur="checkrealDomain(condition.realDomain)"
                  >
                    <el-input
                      v-model="condition.realDomain"
                      size="small"
                      style="width:100%"
                      placeholder="邮箱账号中真实的域名"
                    />
                  </el-form-item>
                </td>
                <td class="td-value">
                  <el-form-item :prop="'conditions[' + index + '].text'">
                    <el-input
                      v-model="condition.mapDomain"
                      size="small"
                      :blur="checkmapDomain(condition.mapDomain)"
                      placeholder="邮箱后台中存在的域名"
                    />
                  </el-form-item>
                </td>
                <td class="td-field">
                  <!-- <span v-if="index == 0">
                    <el-button size="mini" type="primary" @click="checkForm()"
                      >添加</el-button
                    >
                  </span>
                  <span v-else-if="index >= 1">
                    <el-button
                      size="mini"
                      type="danger"
                      @click="handleDelete(index, form.netease.mailDomainlists)"
                      >删除</el-button
                    >
                  </span> -->
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(index, form.netease.mailDomainlists)"
                    >删除</el-button
                  >
                </td>
              </tr>
            </table>
          </el-form-item>
          <el-form-item label="">
            *提示: 邮箱域名映射, 若设置映射关系, 邮箱域名将根据映射关系进行重置!
          </el-form-item>
          <el-form-item label="敏感词替换">
            <el-button size="mini" type="primary" @click="checkNameForm()"
              >添加</el-button
            >
            <table class="condition-table">
              <tr
                v-for="(condition, index) in form.netease.nameKeylists"
                :key="index"
              >
                <td class="td-value">
                  <el-form-item
                    :prop="'conditions[' + index + '].text'"
                    :blur="checkrealName(condition.realName)"
                  >
                    <el-input
                      v-model="condition.realName"
                      size="small"
                      style="width:100%"
                      placeholder="邮箱姓名中存在的敏感词"
                    />
                  </el-form-item>
                </td>
                <td class="td-value">
                  <el-form-item :prop="'conditions[' + index + '].text'">
                    <el-input
                      v-model="condition.mapName"
                      size="small"
                      :blur="checkmapName(condition.mapName)"
                      placeholder="要替换后的关键字"
                    />
                  </el-form-item>
                </td>
                <td class="td-field">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(index, form.netease.nameKeylists)"
                    >删除</el-button
                  >
                </td>
              </tr>
            </table>
          </el-form-item>
          <el-form-item label="">
            *提示: 邮箱姓名敏感词替换, 若设置替换关系,
            邮箱姓名中将根据替换关系进行重置!
          </el-form-item>
        </el-card>
        <!--同步设置-->
        <el-card class="box-card">
          <div slot="header" class="box-card-header">
            <span>同步设置</span>
            <save-button @click="handleSave">保存设置</save-button>
          </div>
          <el-form-item label="同步管理器">
            <el-select v-model="form.ldap.manager">
              <el-option
                v-for="manager in managers"
                :key="manager.assemblyFile"
                :value="manager.assemblyFile"
                :label="
                  `${manager.name}[${manager.series}(${manager.version})]`
                "
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="启动参数">
            <el-input
              type="textarea"
              :rows="4"
              resize="none"
              v-model="form.ldap.managerArgs"
              placeholder="account.mobile=mobile\naccount.job=title"
            ></el-input>
          </el-form-item>
          <el-form-item label="域名修正">
            <el-checkbox v-model="form.netease.disableDomainFix"
              >禁用域名修正(修正非中间件设置域名下的邮箱域名,
              邮箱下包含多域名时建议开启)</el-checkbox
            >
          </el-form-item>
        </el-card>
        <!--任务设置-->
        <el-card class="box-card">
          <div slot="header" class="box-card-header">
            <span>任务设置</span>
            <save-button @click="handleSave">保存设置</save-button>
          </div>
          <el-form-item label="执行时间">
            <el-input v-model="form.sync.syncTime"></el-input>
          </el-form-item>
          <el-form-item label="执行周期">
            <el-select v-model="form.sync.syncInterval">
              <el-option :value="0" label="不执行周期同步"></el-option>
              <el-option :value="60" label="1小时同步一次"></el-option>
              <el-option :value="120" label="2小时同步一次"></el-option>
              <el-option :value="240" label="4小时同步一次"></el-option>
              <el-option :value="480" label="8小时同步一次"></el-option>
              <el-option :value="1440" label="24小时同步一次"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="超时报警">
            单次同步任务执行超过
            <el-input-number
              v-model="form.sync.runningTimeLimit"
              style="width: 130px"
              :min="10"
            />
            分钟未结束时报警
          </el-form-item>
        </el-card>
        <!--登录设置-->
        <el-card class="box-card" v-if="islogin">
          <div slot="header" class="box-card-header">
            <span>登录设置</span>
            <save-button @click="handleSave">保存设置</save-button>
          </div>
          <el-form-item label="登录地址">
            <el-input v-model="form.netease.webMails"></el-input>
          </el-form-item>
          <el-form-item label="活体检测">
            <el-checkbox v-model="form.netease.useBehaviourVerification"
              >登录时使用行为验证码进行活体检测</el-checkbox
            >
          </el-form-item>
          <el-form-item label="登录策略">
            <el-checkbox v-model="form.netease.simpleLoginCheck"
              >使用快速登录验证</el-checkbox
            >
          </el-form-item>

          <el-form-item label="登录公钥">
            <el-input
              type="textarea"
              :rows="4"
              resize="none"
              placeholder="登录密码加密公钥, 公钥需要Hex格式, 如不修改请留空."
              v-model="form.netease.loginPubKey"
            ></el-input>
          </el-form-item>
          <el-form-item label="登录私钥">
            <el-input
              type="textarea"
              :rows="4"
              resize="none"
              placeholder="登录密码解密私钥, 私钥需要XML格式, 如不修改请留空."
              v-model="form.netease.loginPriKey"
            ></el-input>
          </el-form-item>
        </el-card>
        <!--用户设置-->
        <el-card class="box-card">
          <div slot="header" class="box-card-header">
            <span>用户设置</span>
            <save-button @click="handleSave">保存设置</save-button>
          </div>
          <el-form-item label="自动创建">
            <el-checkbox v-model="form.netease.isAutoCreate"
              >是否自动创建新增账号</el-checkbox
            >
          </el-form-item>
          <el-form-item label="收发权限">
            <el-checkbox v-model="form.sync.setRsLimit"
              >同步收发权限</el-checkbox
            >
          </el-form-item>
          <el-form-item label="" v-show="form.sync.setRsLimit">
            <el-checkbox v-model="form.sync.nextForceSetRsLimit"
              >下次同步时强制更新收发权限设置（同步结束后自动关闭）</el-checkbox
            >
          </el-form-item>
          <el-form-item label="邮件归档">
            <el-checkbox v-model="form.sync.setArchive"
              >同步邮件归档</el-checkbox
            >
          </el-form-item>
          <el-form-item label="" v-show="form.sync.setArchive">
            <el-checkbox v-model="form.sync.nextForceSetArchive"
              >下次同步时强制更新邮件归档设置（同步结束后自动关闭）</el-checkbox
            >
          </el-form-item>
          <el-form-item label="登录权限">
            <el-checkbox v-model="form.sync.nextForceSetRight"
              >下次同步时强制更新登录权限设置（同步结束后自动关闭）</el-checkbox
            >
          </el-form-item>
          <el-form-item label="重置手机">
            <el-checkbox v-model="form.sync.nextBindmobile"
              >下次同步时强制重置密保手机（同步结束后自动关闭）</el-checkbox
            >
          </el-form-item>
          <el-form-item label="初始密码">
            <el-input
              v-model="form.netease.defaultPassword"
              placeholder="若为空, 则新增账号生成随机密码; 初始密码规则需与邮箱后台密码规则一致"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮件通知">
            <el-checkbox v-model="form.netease.isRandomPass"
              >是否开启新增账号初始密码邮件通知服务</el-checkbox
            >
          </el-form-item>
          <el-form-item label="接收地址" v-if="form.netease.isRandomPass">
            <el-input
              v-model="form.netease.noticeEmails"
              placeholder="用于新增账号初始密码接受的邮件地址,多个地址使用','分割"
            ></el-input>
          </el-form-item>
          <el-form-item label="初始策略">
            <el-select v-model="form.netease.defaultPasschangeReq">
              <el-option
                v-for="(text, key) in PASSCHANGE_REQ_TEXT"
                :key="key"
                :value="Number(key)"
                :label="text"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="邮箱账号">
            <el-select v-model="form.netease.mailAttr">
              <el-option value="[name]" label="DN名称"></el-option>
              <el-option
                v-for="attr in userAttrs"
                :key="attr.name"
                :value="attr.name"
                :label="`${attr.title}(${attr.name})`"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="显示名称">
            <el-select v-model="form.netease.displayNameAttr">
              <el-option value="[name]" label="DN名称"></el-option>
              <el-option
                v-for="attr in userAttrs"
                :key="attr.name"
                :value="attr.name"
                :label="`${attr.title}(${attr.name})`"
              ></el-option>
            </el-select>
          </el-form-item>
          <!--<el-form-item label="实际名称">
            <el-select v-model="form.netease.realNameAttr">
              <el-option value="[name]" label="DN名称"></el-option>
              <el-option
                v-for="attr in userAttrs"
                :key="attr.name"
                :value="attr.name"
                :label="`${attr.title}(${attr.name})`"
              ></el-option>
            </el-select>
          </el-form-item>-->
          <!--<el-form-item label="邮箱账号">
            <el-select v-model="form.netease.generalMailAttr">
              <el-option value="[name]" label="DN名称"></el-option>
              <el-option
                  v-for="attr in allAttrs"
                  :key="attr.name"
                  :value="attr.name"
                  :label="`${attr.title}(${attr.name})`"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="显示名称">
            <el-select v-model="form.netease.generalDisplayNameAttr">
              <el-option value="[name]" label="DN名称"></el-option>
              <el-option
                  v-for="attr in allAttrs"
                  :key="attr.name"
                  :value="attr.name"
                  :label="`${attr.title}(${attr.name})`"
              ></el-option>
            </el-select>
          </el-form-item>-->
          <!--<el-form-item label="实际名称">-->
          <el-form-item label="密保手机">
            <el-select v-model="form.netease.mobileAttr">
              <el-option value="mobile" label="移动电话"></el-option>
              <el-option
                v-for="attr in userAttrs"
                :key="attr.name"
                :value="attr.name"
                :label="`${attr.title}(${attr.name})`"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="描述">
            <el-select v-model="form.netease.createTimeAttr">
              <el-option value="description" label="自定义描述"></el-option>
              <el-option
                v-for="attr in userAttrs"
                :key="attr.name"
                :value="attr.name"
                :label="`${attr.title}(${attr.name})`"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="部门名称">
            <el-select v-model="form.netease.generalRealNameAttr">
              <el-option value="[name]" label="DN名称"></el-option>
              <el-option
                v-for="attr in allAttrs"
                :key="attr.name"
                :value="attr.name"
                :label="`${attr.title}(${attr.name})`"
              ></el-option>
            </el-select>
          </el-form-item>
          <!--  <el-form-item label="部门初始化">
            单次部门同步任务线程
            <el-input-number
              v-model="form.sync.syncUnitTaskPackageCount"
              style="width: 130px"
              :min="1"
              :max="50"
            />
            (中间件初始化同步时建议设置1)
          </el-form-item> -->
        </el-card>
        <!--邮件列表设置-->
        <el-card class="box-card" v-if="ismailist">
          <div slot="header" class="box-card-header">
            <span>邮件列表设置</span>
            <save-button @click="handleSave">保存设置</save-button>
          </div>
          <el-form-item label="列表打散">
            <el-checkbox v-model="form.netease.enableMaillistScatter"
              >将多级嵌套的通讯组同步为纯人员形式的网易邮件列表</el-checkbox
            >
          </el-form-item>
          <el-form-item label="列表上限">
            <el-input-number
              v-model="form.netease.maillistMaxSize"
              :min="2"
              :max="99999"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="通讯组">
            <el-checkbox v-model="form.sync.syncGroup"
              >同步通讯组至邮件列表</el-checkbox
            >
          </el-form-item>
          <el-form-item label="" v-show="form.sync.syncGroup">
            <el-checkbox v-model="form.sync.syncSecurityGroup"
              >同步通讯组时包含安全组</el-checkbox
            >
          </el-form-item>
          <el-form-item label="初始权限">
            <el-select v-model="form.netease.defaultMaillistRight">
              <el-option
                v-for="(text, key) in MAILLIST_RIGHT_TEXT"
                :key="key"
                :value="Number(key)"
                :label="text"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="授权用户">
            <el-input v-model="form.netease.defaultSafelist"></el-input>
          </el-form-item>
          <el-form-item label="通讯录可见">
            <el-select v-model="form.netease.defaultAddrVisible">
              <el-option
                v-for="(text, key) in Addr_Visible_TEXT"
                :key="key"
                :value="Number(key)"
                :label="text"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="查看组成员">
            <el-select v-model="form.netease.defaultMemberVisible">
              <el-option
                v-for="(text, key) in Member_Visible_TEXT"
                :key="key"
                :value="Number(key)"
                :label="text"
              ></el-option>
            </el-select>
            (是否允许查看列表成员)
          </el-form-item>
          <el-form-item label="邮箱账号">
            <el-select v-model="form.netease.maillistMailAttr">
              <el-option value="[name]" label="DN名称"></el-option>
              <el-option
                v-for="attr in groupAttrs"
                :key="attr.name"
                :value="attr.name"
                :label="`${attr.title}(${attr.name})`"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="显示名称">
            <el-select v-model="form.netease.maillistDisplayNameAttr">
              <el-option value="[name]" label="DN名称"></el-option>
              <el-option
                v-for="attr in groupAttrs"
                :key="attr.name"
                :value="attr.name"
                :label="`${attr.title}(${attr.name})`"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="删除上限">
            单次同步删除邮件列表超过
            <el-input-number
              v-model="form.sync.maillistDeleteLimit"
              style="width: 130px"
              :min="0"
            />
            个时终止同步任务
          </el-form-item>
          <!--<el-form-item label="实际名称">
            <el-select v-model="form.netease.maillistRealNameAttr">
              <el-option value="[name]" label="DN名称"></el-option>
              <el-option
                v-for="attr in groupAttrs"
                :key="attr.name"
                :value="attr.name"
                :label="`${attr.title}(${attr.name})`"
              ></el-option>
            </el-select>
          </el-form-item>-->
        </el-card>
        <!--账户删除设置-->
        <el-card class="box-card" v-if="isaccountdelete">
          <div slot="header" class="box-card-header">
            <span>账户删除设置</span>
            <save-button @click="handleSave">保存设置</save-button>
          </div>
          <el-form-item label="删除账户">
            <el-checkbox v-model="form.sync.removeDeleted"
              >处理{{ dataSource }}中删除的账户</el-checkbox
            >
          </el-form-item>
          <el-form-item label="" v-show="form.sync.removeDeleted">
            删除/取消同步{{ dataSource }}账户时，在
            <el-input-number
              v-model="form.sync.removeDeletedDalay"
              style="width: 130px"
              :max="99999"
              :min="0"
            />
            天后
            <el-select
              v-model="form.sync.removeDeletedAsDisabled"
              @change="freezing()"
              style="width: 80px"
            >
              <el-option :value="false" label="删除"></el-option>
              <el-option :value="true" label="禁用"></el-option>
            </el-select>
            网易邮箱
          </el-form-item>
          <el-form-item label="禁用账户">
            <el-checkbox v-model="form.sync.removeDisabled"
              >处理{{ dataSource }}中禁用的账户</el-checkbox
            >
          </el-form-item>
          <el-form-item label="" v-show="form.sync.removeDisabled">
            禁用网易邮箱时，使用
            <el-select v-model="form.sync.simDisable" style="width: 106px">
              <el-option :value="false" label="彻底禁用"></el-option>
              <el-option :value="true" label="登录禁用"></el-option>
            </el-select>
            方式，并在禁用
            <el-input-number
              v-model="form.sync.removeDisabledDelay"
              :max="99999"
              style="width: 130px"
              :min="0"
            />
            天后删除网易邮箱（不删除{{ dataSource }}账户）
          </el-form-item>
          <el-form-item label="删除上限">
            单次同步删除或禁用账号超过
            <el-input-number
              v-model="form.sync.accountDeleteLimit"
              style="width: 130px"
              :min="0"
            />
            个时终止同步任务
          </el-form-item>
        </el-card>
        <!--密码强度设置-->
        <el-card class="box-card" v-if="ispassstrong">
          <div slot="header" class="box-card-header">
            <span>密码强度设置</span>
            <save-button @click="handleSave">保存设置</save-button>
          </div>
          <el-form-item label="字符类型">
            <el-checkbox
              v-model="form.sync.passwordCharCheck"
              class="merge-next"
              >密码组成至少包含</el-checkbox
            >
            <el-select
              v-model="form.sync.passwordCharType"
              style="width: 60px"
              @change="form.sync.passwordCharCheck = true"
            >
              <el-option :value="2" label="2"></el-option>
              <el-option :value="3" label="3"></el-option>
              <el-option :value="4" label="4"></el-option>
            </el-select>
            <el-checkbox v-model="form.sync.passwordCharCheck"
              >种字符</el-checkbox
            >
          </el-form-item>
          <el-form-item label="长度限制">
            <el-checkbox
              v-model="form.sync.passwordLengthCheck"
              class="merge-next"
              >密码长度为</el-checkbox
            >
            <el-input-number
              v-model="form.sync.passwordMinLength"
              @change="form.sync.passwordLengthCheck = true"
              style="width: 130px"
              :min="6"
              :max="16"
            />
            <el-checkbox v-model="form.sync.passwordLengthCheck"
              >至16位</el-checkbox
            >
          </el-form-item>
          <el-form-item label="密码独立性">
            <el-checkbox v-model="form.sync.passwordNoAccountName"
              >密码不能包含邮箱账号</el-checkbox
            >
          </el-form-item>
          <el-form-item label="密码连续性">
            <el-checkbox
              v-model="form.sync.passwordNoConsecutiveAndIdentical"
              class="merge-next"
              >连续3位以上字符不能连续或相同（例如123、654、abc、cba、aaa、111）</el-checkbox
            >
          </el-form-item>
          <el-form-item label="">
            <strong>
              *注: 开启了中间件自定义webmail登陆且数据源为AD域控,
              此处密码规则需要与邮箱后台(AD域控)设置的密码规则一致</strong
            >
          </el-form-item>
        </el-card>
        <!--数据存储设置-->
        <el-card class="box-card" v-if="isdatasave">
          <div slot="header" class="box-card-header">
            <span>数据存储设置</span>
            <save-button @click="handleSave">保存设置</save-button>
          </div>
          <el-form-item label="数据文件">
            <el-input
              v-model="form.sync.syncRecordFile"
              placeholder="建议保持默认设置"
            ></el-input>
          </el-form-item>
          <el-form-item label="日志目录">
            <el-input
              v-model="form.sync.syncLogPath"
              placeholder="建议保留默认设置"
            ></el-input>
          </el-form-item>
          <el-form-item label="登录文件">
            <el-input
              v-model="form.sync.userLoginFile"
              placeholder="建议保留默认设置"
            ></el-input>
          </el-form-item>
          <el-form-item label="日志查看">
            <el-checkbox v-model="form.sync.showSameAndIgnore"
              >显示比对一致和忽略操作记录</el-checkbox
            >
          </el-form-item>
          <el-form-item label="日志清理">
            删除
            <el-input-number
              v-model="form.sync.logRetentionDays"
              style="width: 130px"
              :min="1"
            />
            天前的同步日志
          </el-form-item>
        </el-card>
        <el-card class="box-card">
          <div slot="header" class="box-card-header">
            <span>分区容量预警设置</span>
            <save-button @click="handleSave">保存设置</save-button>
          </div>
          <el-form-item label="运行目录">
            <el-input
              v-model="form.sync.hardDiskPath"
              placeholder="请按照真实中间件部署目录填写磁盘路径"
            ></el-input>
          </el-form-item>
          <el-form-item label="磁盘熔断值">
            <el-input
              v-model="form.sync.noticeHardDisk"
              placeholder="磁盘剩余容量熔断值"
            ></el-input>
            <span
              >*注:单位M, 如熔断值设置100M, 可用磁盘小于100M时同步任务终止</span
            >
          </el-form-item>
        </el-card>
        <!--通知邮箱设置-->
        <el-card class="box-card" v-if="ismailsetting">
          <div slot="header" class="box-card-header">
            <span>通知邮箱设置</span>
            <span>
              <el-button type="text" @click="noticeSendTest"
                >发送测试</el-button
              >
              <save-button @click="handleSave">保存设置</save-button>
            </span>
          </div>
          <el-form-item label="主机地址">
            <el-input v-model="form.smtp.host"></el-input>
          </el-form-item>
          <el-form-item label="传输加密">
            <el-checkbox v-model="form.smtp.useSsl">启用SSL</el-checkbox>
          </el-form-item>
          <el-form-item label="端口号">
            <el-input v-model="form.smtp.port"></el-input>
          </el-form-item>
          <el-form-item label="连接用户名">
            <el-input v-model="form.smtp.user"></el-input>
          </el-form-item>
          <el-form-item label="连接密码">
            <el-input type="password" v-model="form.smtp.password"></el-input>
          </el-form-item>
        </el-card>
        <!--短信接口设置-->
        <el-card class="box-card" v-if="issms">
          <div slot="header" class="box-card-header">
            <span>短信接口设置</span>
            <save-button @click="handleSave">保存设置</save-button>
          </div>
          <el-form-item label="连接用户名">
            <el-input v-model="form.sms.account"></el-input>
          </el-form-item>
          <el-form-item label="连接密码">
            <el-input type="password" v-model="form.sms.password"></el-input>
          </el-form-item>
          <el-form-item label="短信模板">
            <el-input
              type="textarea"
              :rows="4"
              resize="none"
              v-model="form.sms.template"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <strong
              >*提示: 在自定义webmail登陆页开启密码找回功能时设置,
              短信接口需要单独购买!</strong
            ></el-form-item
          >
        </el-card>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
import UTIL from "@/api/sync/util";
import _ from "lodash";
import { mapState } from "vuex";
import { PASSCHANGE_REQ_TEXT } from "@/constant/passchangeReq";
import { MAILLIST_RIGHT_TEXT } from "@/constant/maillistRight";
import { Addr_Visible_TEXT } from "@/constant/addrVisible";
import { Member_Visible_TEXT } from "@/constant/memberVisible";
import HOME from "@/api/sync/home";
import LdapTest from "./ldap-test";
import SmtpTest from "./smtp-test";
import ADMIN from "@/api/admin";

export default {
  data() {
    return {
      PASSCHANGE_REQ_TEXT,
      MAILLIST_RIGHT_TEXT,
      Addr_Visible_TEXT,
      Member_Visible_TEXT,
      form: null,
      current: "0",
      cards: [],
      offsets: [],
      managers: [],
      menuConfig: null,
      ismailsetting: true,
      issms: true,
      islogin: true,
      ismailist: true,
      ispassstrong: true,
      isdatasave: true,
      isaccountdelete: true,
      dataSource: "LDAP"
    };
  },
  computed: {
    ...mapState(["options", "schemas"]),
    label: () => card => card.$slots.header[0].children[0].children[0].text,
    mapAttrs: vm => filter =>
      vm.schemas
        ?.filter(filter)
        .map(schema => schema.attrs)
        .flat()
        .reduce(
          (arr, attr) =>
            arr.find(a => a.name === attr.name) ? arr : [...arr, attr],
          []
        ) ?? [],
    allAttrs: vm => vm.mapAttrs(() => true),
    userAttrs: vm => vm.mapAttrs(schema => schema.isUser),
    groupAttrs: vm => vm.mapAttrs(schema => schema.isGroup),
    containerAttrs: vm => vm.mapAttrs(schema => schema.isContainer)
  },
  async created() {
    // 等待Store初始化完成
    await this.$store.init;
    await this.getOptions();
    await this.getManagers();
    this.form = _.cloneDeep(this.options);
    this.form.netease.key = "";
    this.form.netease.loginPriKey = "";
    this.form.netease.loginPubKey = "";
    /* if (!this.form.netease.mailDomainlists.length) {
      this.form.netease.mailDomainlists.push(this.createCondition());
    } */

    if (this.form.ldap.manager === "WorkWeiXinManager") {
      this.dataSource = "企业微信";
    } else if (this.form.ldap.manager === "WorkWeiXinExtManager") {
      this.dataSource = "企业微信";
    } else if (this.form.ldap.manager === "DingDingManager") {
      this.dataSource = "钉钉";
    } else if (this.form.ldap.manager === "FsManager") {
      this.dataSource = "飞书";
    }

    let response = await ADMIN.MENU();
    if (response.data.state) {
      this.menuConfig = response.data.config;

      this.ismailsetting = this.menuConfig["通知邮箱设置"] !== false;
      this.issms = this.menuConfig["短信接口设置"] !== false;
      this.islogin = this.menuConfig["登陆设置"] !== false;
      this.ismailist = this.menuConfig["邮件列表设置"] !== false;
      this.ispassstrong = this.menuConfig["密码强度设置"] !== false;
      this.isdatasave = this.menuConfig["数据存储设置"] !== false;
      this.isaccountdelete = this.menuConfig["账号删除设置"] !== false;
    }
  },

  updated() {
    if (this.$refs.form) {
      this.cards = this.$refs.form.$children;
      this.offsets = this.cards.map(c => c.$el.offsetTop - 20);
    }
  },
  methods: {
    async getOptions() {
      const response = await UTIL.OPTIONS();
      if (response.data.state) {
        await this.$store.dispatch("setOptions", response.data.options);
      }
    },
    async getManagers() {
      let response = await UTIL.MANAGERS();
      if (response.data.state) {
        this.managers = response.data.managers;
      }
    },
    handleClick(tab) {
      let top = this.offsets[tab.index];
      if (this.$refs.main.$el.scrollTo) {
        this.$refs.main.$el.scrollTo({ top, behavior: "smooth" });
      } else {
        this.$refs.main.$el.scrollTop = top;
      }
    },
    handleScroll() {
      let scrollTop = this.$refs.main.$el.scrollTop;
      let current = this.offsets.findIndex(o => o >= scrollTop);
      current = current !== -1 ? current : this.offsets.length - 1;
      if (
        Math.sign(this.scrollTop - scrollTop) ===
        Math.sign(this.current - current)
      ) {
        this.current = current.toString();
      }
      this.scrollTop = scrollTop;
    },
    freezing() {
      if (
        this.form.sync.removeDeleted &&
        this.form.sync.removeDeletedAsDisabled
      ) {
        //console.log("开启删除&禁用0:" + this.form.sync.RemoveDisabled);
        this.form.sync.RemoveDisabled = true;
        //console.log("开启删除&禁用1:" + this.form.sync.RemoveDisabled);
      }
    },
    async handleSave() {
      try {
        if (this.form.netease.domain !== this.options.netease.domain) {
          if (this.form.netease.domain) {
            // eslint-disable-next-line no-constant-condition
            while (true) {
              let { value: token } = await this.$prompt(
                "您已修改网易主域名，请输入动态口令：",
                {
                  closeOnClickModal: false
                }
              );
              let response = await HOME.ENCRYPT({
                token,
                content: this.form.netease.domain
              });
              if (response.data.state) {
                this.form.netease.encryptedDomain = response.data.encrypted;
                break;
              } else {
                await this.$alert(response.data.message ?? "动态口令错误", {
                  title: "设置保存失败",
                  type: "error"
                });
              }
            }
          } else {
            this.form.netease.encryptedDomain = "";
          }
        }

        // 增加域名映射判断 202110221
        /* let chongfu = false;
        let rdomain = new Array();
        if (this.form.netease.mailDomainlists.length > 0) {
          for (let i = this.form.netease.mailDomainlists.length; i >= 0; i--) {
            let rdom = this.form.netease.mailDomainlists[i - 1].realDomain;
            console.log(this.form.netease.mailDomainlists[i - 1].realDomain);
            if (rdom === "") {
              //this.$message.error("域名映射保存失败,映射域名中存在空数据!");
              console.log("域名映射保存失败,映射域名中存在空数据!");
              return false;
            } else if (rdomain.indexOf(rdom) != -1) {
              console.log("判断包含:" + rdomain.indexOf(rdom));
              chongfu = true;
              return false;
            } else {
              rdomain.push(rdom);
            }
          }
          if (chongfu) {
            console.log("域名映射保存失败, 存在相同的映射域名!");
            // this.$message.error("域名映射保存失败, 存在相同的映射域名!");
          }
        } */
        // console.log(this.form);
        const subForm = _.cloneDeep(this.form);
        if (subForm.netease.key === "") {
          subForm.netease.key = this.options.netease.key;
        }
        if (subForm.netease.loginPriKey === "") {
          subForm.netease.loginPriKey = this.options.netease.loginPriKey;
        }
        if (subForm.netease.loginPubKey === "") {
          subForm.netease.loginPubKey = this.options.netease.loginPubKey;
        }
        let response = await HOME.SETTING(subForm);
        if (response.data.state) {
          await this.$store.dispatch("setOptions", subForm);
          this.$message.success("全部设置保存成功");
        } else {
          this.$message.error(response.data.message ?? "设置保存成功失败");
        }
        // eslint-disable-next-line no-empty
      } catch {}
    },
    async ldapConnectionTest() {
      try {
        const h = this.$createElement;
        await this.$msgbox({
          title: "连接测试",
          message: h("ldap-test", { props: { ldap: this.form.ldap } }),
          callback(action, instance) {
            delete instance.$slots.default;
            instance.$forceUpdate();
          },
          confirmButtonText: "取消"
        });
        // eslint-disable-next-line no-empty
      } catch {}
    },
    async noticeSendTest() {
      try {
        const h = this.$createElement;
        await this.$msgbox({
          title: "连接测试",
          message: h("smtp-test", { props: { smtp: this.form.smtp } }),
          callback(action, instance) {
            delete instance.$slots.default;
            instance.$forceUpdate();
          },
          confirmButtonText: "取消"
        });
        // eslint-disable-next-line no-empty
      } catch {}
    },

    // 增加域名映射结点
    checkForm() {
      this.form.netease.mailDomainlists.push(this.createCondition());
    },
    // 创建空白域名映射结点
    createCondition() {
      return {
        realDomain: "",
        mapDomain: ""
      };
    },
    checkNameForm() {
      this.form.netease.nameKeylists.push(this.createNameCondition());
    },
    createNameCondition() {
      return {
        realName: "",
        mapName: ""
      };
    },
    //删除域名映射结点
    handleDelete(index, rows) {
      rows.splice(index, 1);
    },
    // 添加验证域名验证是否存在
    checkrealDomain(realDomain) {
      let mails =
        realDomain !== ""
          ? this.form.netease.mailDomainlists.filter(
              maillist => maillist.realDomain == realDomain
            )
          : [];
      const reg = /^^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/;
      if (realDomain !== "" && !reg.test(realDomain)) {
        /*  this.$alert("输入的映射域名【" + realDomain + "】格式不正确,请更换!", {
          title: "设置失败",
          type: "error"
        }); */
      }
      if (realDomain !== "" && mails.length > 1) {
        this.$message({
          message: "域名映射关系中已存在映射域名【" + realDomain + "】请更换!",
          type: "warning"
        });
        /* this.$alert(
          "域名映射关系中已存在映射域名【" + realDomain + "】请更换!",
          {
            title: "设置失败",
            type: "error"
          }
        ); */
      }
    },
    checkmapDomain(mapDomain) {
      var domain =
        this.form.netease.domain +
        (this.form.netease.subDomains !== ""
          ? "," + this.form.netease.subDomains
          : "");

      if (domain.indexOf(mapDomain) === -1) {
        console.log("该映射域名【" + mapDomain + "】不在邮箱域名中");
      }
    },
    //20221229验证敏感词是否存在
    checkrealName(realName) {
      let mails =
        realName !== ""
          ? this.form.netease.nameKeylists.filter(
              maillist => maillist.realName == realName
            )
          : [];
      if (realName !== "" && mails.length > 1) {
        this.$message({
          message: "敏感词列表中已存在【" + realName + "】请更换!",
          type: "warning"
        });
      }
    },
    checkmapName(mapName) {
      if (mapName.indexOf("管理员") !== -1) {
        this.$message({
          message: "该替换的名称,包含【管理员】请更换!",
          type: "warning"
        });
        console.log("该替换的名称【" + mapName + "】包含敏感词");
      }
    }
  },
  components: {
    // eslint-disable-next-line vue/no-unused-components
    LdapTest,
    // eslint-disable-next-line vue/no-unused-components
    SmtpTest,
    "save-button": {
      render(h) {
        return h("el-tooltip", { props: { placement: "top" } }, [
          h("div", { slot: "content" }, [
            "点击任意保存按钮都将",
            h("br"),
            "保存本页面内全部设置"
          ]),
          h(
            "el-button",
            { props: { type: "text" }, on: this.$listeners },
            this.$slots.default
          )
        ]);
      }
      // template: `
      //         <el-tooltip placement="top">
      //           <div slot="content">
      //             点击任意保存按钮都将<br />保存本页面内全部设置
      //           </div>
      //           <el-button type="text" v-on="$listener">保存设置</el-button>
      //         </el-tooltip>`
    }
  }
};
</script>

<style lang="less" scoped>
.el-aside {
  padding: 20px 10px;
  position: relative;
  .el-tabs {
    position: absolute;
    right: 0;
  }
}
.el-main {
  padding-left: 15px;
}
.box-card {
  max-width: 680px;
  margin: 0 auto 20px;
  ::v-deep .el-card__header {
    padding: 12px 18px;
  }
}
.box-card-header {
  display: flex;
  justify-content: space-between;
  line-height: 20px;
  font-weight: bold;
  .el-button {
    padding: 3px 0;
  }
}
.el-form {
  .el-select {
    width: 100%;
  }
  .el-input-number {
    //width: 100%;
  }
}
.el-checkbox.merge-next {
  margin-right: 5px;
  + * + .el-checkbox::v-deep {
    .el-checkbox__input {
      display: none;
    }
    .el-checkbox__label {
      padding-left: 5px;
    }
  }
}
.el-table .cell {
  line-height: 32px;
}
.el-table td,
.el-table th {
  padding: 3px 0;
}
.edit-dialog .el-table td,
.edit-dialog .el-table th {
  padding: 6px 0;
}
.el-table-column--selection .cell {
  padding-right: 10px;
}

.condition-table {
  border-spacing: 0;
  width: 100%;
  .tr-add * {
    color: #cccccc;
  }
  td {
    &:nth-child(n + 2) {
      padding-left: 4px;
    }
    .el-select,
    .el-input,
    .el-input-number,
    .el-date-editor {
      width: 100%;
    }
  }
  .el-form-item {
    margin-bottom: 0;
  }
}
.input-addition {
  padding-top: 6px;
  textarea {
    font-family: "Microsoft YaHei";
  }
}
</style>
